import React from "react";
import Typography from "@material-ui/core/Typography";

const Subtitle1 = (props: any) => (
  <Typography variant="subtitle1" component="h6" gutterBottom {...props} />
);

export default Subtitle1;
